import * as React from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import { LabelContext } from "../core/label.context";
import { GeneralContext } from '../core/general.context';
import {ItemStyle, ConfiguratorStyle, ProductDetailStyle} from "./configurator.style"; 
import "slick-carousel/slick/slick.css"; 
import "./configurator.css"; 
import "slick-carousel/slick/slick-theme.css";


export const Loanching = (props: any) => {
	const container = document.getElementById("landing-fab-root");
	const { setStep, setShow, show, setSelectedProduct, selectedProduct, families, setItems} = React.useContext(GeneralContext);
	
	const handleClose = () => { setShow(false); setStep(0); setItems(null); setSelectedProduct(null)};
  	const handleShow = () => {setShow(true); setItems(families)};
    
    const { t } = React.useContext(LabelContext);
  	
	//{t("ecommerce.common.related.title")}
	if (!container)
        return null;
    else
		return ReactDOM.createPortal( 
			<>
		      <Button variant="button-primary cta-black btn-cta-btn" onClick={() => {handleShow(); setShow(true)}}>
		        {t("openButton") || "open"}
		      </Button>

		      <Modal
		        show={show}
		        onHide={handleClose}
		        backdrop="static"
		        keyboard={false}
		        fullscreen={true}
				className= {"configurator-modal "}		        
		      >
		        <Modal.Header>
					<div className="action-wrap">
						<Button className="close txt-white" onClick={handleClose}>
							{t("closeButton") || "close"} <span aria-hidden="true">&times;</span>
						</Button>
				  	</div>
		        </Modal.Header>
		        <Modal.Body>
		          <Configurator />
		        </Modal.Body>
		        {selectedProduct && 
		        <Modal.Footer>
					{selectedProduct && <ProductDetail product={selectedProduct}/> }
		        </Modal.Footer>
		        }
		      </Modal>
			</>,
	container)
}

export const Configurator = (props: any) => {
	const { t } = React.useContext(LabelContext);

	const {selectedProduct, setPreviousState, step, items,} = React.useContext(GeneralContext);

	const settings = {
		dots: true,
		centerMode: false,
		centerPadding: '0',
		infinite: false,
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: true,
		responsive: [	
			{	
				breakpoint: 1600,
				settings: { 
						infinite: false,
						swipe: true,
						slidesToShow: 5,
						centerMode: false,
					}
				},
			{	
			breakpoint: 1440,
			settings: { 
					infinite: false,
					swipe: true,
					slidesToShow: 3,
					arrows: true, 
					centerMode: false,
				}
			},
			{
			breakpoint: 1024,
			settings: { 
					infinite: false,
					swipe: true,
					slidesToShow: 2,
					arrows: true,
					centerMode: false,
				}
			},
			{
				breakpoint: 500,
				settings: { 
						infinite: false,
						swipe: true,
						slidesToShow: 1,
						arrows: true,
						centerMode: false,
					}
				}
		],      
    };
	
	return (
		<>
		<ConfiguratorStyle>			
	        <div className="progressbar"><div className={"bg-progress step" +  step + (selectedProduct ? '-last' : '')}></div></div>
	        <div className="title-wrapper">	     
	        	
			    <div className="title">
					{step===0 && t("titleStep1")}
					{step===1 && t("titleStep1")}
					{step===2 && t("titleStep2")}
					{step===3 && selectedProduct && t("titleStep2")}
					{step===3 && !selectedProduct && t("titleStep3")}
					{step===4 && t("titleStep3")}
				</div>

			        {step > 1 && step <= 4 && <a className="cta-back" onClick={ () => { setPreviousState(step); } }
			    		><span className="back-icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clipPath="url(#clip0_1_3)">
							<path d="M19.1421 14.1421L10 5L0.857866 14.1421" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
							</g>
							<defs>
							<clipPath id="clip0_1_3">
							<rect width="20" height="20" fill="white"/>
							</clipPath>
							</defs>
							</svg>
						
						</span> {t("backButton") || "back"}</a>
			    	}
			    		 
	       
	        </div>
	    	<Slider {...settings} className="item-container">
	        	{items && items.length>0 && items.map((item:any, i:any) => {
	        		let key = Object.keys(item)[0];
					let sku 
					step < 1 ? sku = item.name : sku = item.item?.sku
	        		let title
					let img
					step < 1 ? title = item.name : (item.item.color === "45" ? title = item.item?.specialColorTxt : title = item.item?.colorTxt)
					step < 1 ? img = item.activeImage : img = item.item?.mainImage
					let famDesc = item.description ? item.description.split('|') : ''
					let famCat = famDesc ? famDesc[0] : ''
					let famDim = famDesc ? famDesc[1] : ''
	        		item = item;
					
	        		return (
	        			<Item key={i} ItemKey={key} img={img} title={title} subtitle={item.type + ' ' + item.size} sku={sku} cat={famCat} dim={famDim} pos={item.position} item={item} />
	        			)
	        	}) 
	        }
	    	</Slider>
        </ConfiguratorStyle>
		</>
	 )
}

export const Item = (props: any) => {
	const {t} = React.useContext(LabelContext);
	const { handleTypeClick, setStep, handleItemClick, selectedType, setSelectedProduct, step } = React.useContext(GeneralContext);
	
	return (
		<>
			{
			    <ItemStyle className="item-wrap" >

			    	<div className={"slider-item step" +  step} onClick={(e) => {
			    		if (step < 1) {
							handleTypeClick(props.sku)
						}
			    		if (step === 2){
							handleItemClick(selectedType, props.sku)
						}
			    		if (step > 2){
							setSelectedProduct(props.sku);
							setStep(4)
						}
			    	}}>
				    	{props.img &&  <div className="image"> <img src={props.img} /></div>}
						{step <= 2 &&
							<div className="title">
								<span  dangerouslySetInnerHTML={{__html: props.title}} />  
							</div>
						}
						{step === 2 &&
							<div className="subtitle">
								<span  dangerouslySetInnerHTML={{__html: props.item.fam}} />
							</div>
						}
						{step > 2 && props.pos === "1" &&
							<><div className="title">
								{t("hinge.right") || "Hinge Right"}
							</div>
							<div className="subtitle">
								<span dangerouslySetInnerHTML={{ __html: props.title }} />
							</div>
							<div className="subtitle">
								<span dangerouslySetInnerHTML={{ __html: props.item.fam }} />
							</div></>
						}
						{step > 2 && props.pos === "2" &&
							<><div className="title">
								{t("hinge.left") || "Hinge Left"}  
							</div>
							<div className="subtitle">
								<span dangerouslySetInnerHTML={{ __html: props.title }} />
							</div>
							<div className="subtitle">
								<span dangerouslySetInnerHTML={{ __html: props.item.fam }} />
							</div></>
						}
						{props.cat &&
							<div className="subtitle">
								<span  dangerouslySetInnerHTML={{__html: props.cat}} />  
							</div>
						}
						{props.dim &&
							<div className="paragraph">
								<span  dangerouslySetInnerHTML={{__html: props.dim}} />  
							</div>
						}
						<a className="cta">
								{t("selectButton") || "select"}
						</a>
			    	</div>
			    </ItemStyle>
			}
		</>
	)
}


export const ProductDetail = (props: any) => {
	const {t} = React.useContext(LabelContext);

	const { step,productsfab,setStep, setSelectedProduct, selectedProduct, } = React.useContext(GeneralContext);
	
	let detail = productsfab.find((item: any) => {return item.item.sku == selectedProduct});

	let description = detail.item?.description.replaceAll(',',' | ')

	setTimeout(function() { 
		document.documentElement.scrollTop = document.documentElement.scrollHeight;
	}, 100);
	
	
	return (
		<ProductDetailStyle>
		<Container fluid="xxl" className="box-product">
			<div className="action-wrap">
				<Button className="close txt-white" onClick={ () => { setSelectedProduct(null); step === 3 ? setStep(2) : setStep(3)}}>
					<span aria-hidden="true">&times;</span>
				</Button>
			</div>
  			<Row className="product-wrap">
  				<Col className="col-image">
	                <div className="image">
						<img src={detail.item?.mainImage} />
	                </div>
  				</Col>
				
					<Col  md="auto" className="product-info">
						<div className="title" dangerouslySetInnerHTML={{__html: detail?.type + ' ' + detail?.size}} />
						<div className="caption" dangerouslySetInnerHTML={{__html: detail.item?.sku}} />
						<div className="subtitle" dangerouslySetInnerHTML={{__html: detail.item.color === "45" ? detail.item?.specialColorTxt : detail.item?.colorTxt}} />
						<div className="paragraph" dangerouslySetInnerHTML={{__html: description}} />

						
						<button type="button" className="cta-link-white action-tablet" onClick={ () => { setSelectedProduct(null); step === 3 ? setStep(2) : setStep(3)}}>
							<span className="back-icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clipPath="url(#clip0_1_3)">
								<path d="M19.1421 14.1421L10 5L0.857866 14.1421" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
								</g>
								<defs>
								<clipPath id="clip0_1_3">
								<rect width="20" height="20" fill="white"/>
								</clipPath>
								</defs>
								</svg>
							
							</span> <span>{t("backButton") || "back"}</span>
						</button>
							
						<a href={t("urlPdp") + detail.item?.sku}   target="_blank" className="cta-white action-tablet"> {t("buyButton") || "buy"}</a> 
						
					</Col>
					<Col className="col-action">
						<div className="actions">

							<button type="button" className="cta-link-white" onClick={ () => { setSelectedProduct(null); step === 3 ? setStep(2) : setStep(3)}}>
								<span className="back-icon">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_1_3)">
									<path d="M19.1421 14.1421L10 5L0.857866 14.1421" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
									</g>
									<defs>
									<clipPath id="clip0_1_3">
									<rect width="20" height="20" fill="white"/>
									</clipPath>
									</defs>
									</svg>
								
								</span> <span>{t("backButton") || "back"}</span>
							</button>
							
							<a href={t("urlPdp") + detail.item?.sku}   target="_blank" className="cta-white"> {t("buyButton") || "buy"}</a> 
						
							{/* <button type="button" className="cta-border-white " onClick={ () => { setSelectedProduct(null); step === 3 ? setStep(2) : setStep(3)}}>
								<span className="txt-brown"> {t("cancelButton") || "cancel"}</span>
							</button> */}
						</div>  					
					</Col>
				
  				
  			</Row>
		</Container>
		</ProductDetailStyle>
	)
}